<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-19 16:47:44
-->
<template>
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div class="type-activite">饲料进出存</div>
      </div>
      <div class="page-list">
        <!-- 搜索栏 -->
        <div class="page-search-content" ref="searchBox">
          <div class="page-big-box">
            <div class="page-search-item">
              <label>养殖场&nbsp;:</label>
              <el-select v-model="params.params.baseId" filterable placeholder="请选择养殖场">
                <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>仓库&nbsp;:</label>
              <el-select v-model="params.params.groupId" filterable placeholder="请选择仓库">
                <el-option label="全部养殖分组" value=""></el-option>
                <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>饲料名称&nbsp;:</label>
              <el-select v-model="params.params.fodderId" filterable placeholder="请选择饲料名称">
                <el-option label="全部饲料名称" value=""></el-option>
                <el-option v-for="item in fodderList" :key="item.id" :label="item.fodderName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 选择日期年月日 -->
            <div class="page-search-date">
              <div class="page-search-item date-selection-box">
                <span @click="params.params.type = 'Y'" :class="[params.params.type == 'Y' ? 'active-date' : '']">年</span>
                <span @click="params.params.type = 'M'" :class="[params.params.type == 'M' ? 'active-date' : '']">月</span>
                <span @click="params.params.type = 'D'" :class="[params.params.type == 'D' ? 'active-date' : '']">日</span>
              </div>
              <div class="page-search-item" v-show="params.params.type === 'Y'">
                <label>年份&nbsp;:</label>
                <el-date-picker value-format="yyyy" format="yyyy" v-model="params.params.year" type="year"
                  placeholder="请选择年份">
                </el-date-picker>
              </div>
              <div class="page-search-item" v-show="params.params.type === 'M'">
                <label>月份区间&nbsp;:</label>
                <el-date-picker v-model="monthRange" format="yyyy-MM" value-format="yyyy-MM" @change="monthChange"
                  type="monthrange" range-separator="~" start-placeholder="开始月份" end-placeholder="结束月份">
                  >
                </el-date-picker>
              </div>
              <div class="page-search-item" v-show="params.params.type === 'D'">
                <label>日期区间&nbsp;:</label>
                <el-date-picker v-model="dateRange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="dateChange"
                  type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div class="page-search-item">
              <!-- 合计 -->
              <label>查询合计&nbsp;:</label>
              <el-checkbox v-model="params.params.total"></el-checkbox>
            </div>

          </div>
          <!-- 按钮 -->
          <div class="page-search-btn">
            <div class="search-btn" @click="search">查询</div>
            <div class="reset-btn" @click="reset">重置</div>
            <div class="search-close-btn">
              <div @click="PageSearchClose" v-if="PageDisplay">
                <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
              </div>
              <div @click="PageSearchOn" v-else>
                <span>展开</span><i class="iconfont icon-List-Collapse"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="page-list-content">
          <!-- 列表 -->
          <div class="page-list-title">
            <div><i class="title-icon"></i>饲料进出存</div>
            <div>单位: {{ orgName }}</div>
            <!-- 年报表 -->
            <div v-if="params.params.type == 'Y'">年份 : {{ showYear }}年</div>
            <!-- 月报表 -->
            <div v-if="params.params.type == 'M'">
              月份 :
              {{ showStartDate }}-{{ showEndDate }}
            </div>
            <!-- 日报表 -->
            <div v-if="params.params.type == 'D'">
              日期 :
              {{ showStartDate }}-{{ showEndDate }}
            </div>
            <div class="page-list-btns">
              <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
                <span class="el-dropdown-link">
                  冻结列<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="y">冻结至"{{
                    fixedColumn.label
                  }}"列</el-dropdown-item>
                  <el-dropdown-item command="n">取消冻结</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span @click="exportTable">
                <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
              </span>
            </div>
          </div>
          <!-- 表格 -->
          <el-table :data="pagelist.list" :max-height="tableHeight" row-key="id" border style="width: 100%"
            :row-class-name="tableRowClassName" @header-click="handleClick">
            <el-table-column :fixed="fixedColumnList[0].fixed"
              :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''" prop="feedingTime" label="时间">
              <template slot-scope="scope">
                <span v-if="scope.row.date">{{ scope.row.date }}</span>
                <span v-if="!scope.row.date">{{ scope.row.startDate }}</span>
              </template>
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[1].fixed"
              :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''" prop="groupName" label="仓库">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[2].fixed"
              :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''" prop="fodderName" label="饲料名称">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[3].fixed"
              :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''" prop="specification" label="规格">
            </el-table-column>
            <el-table-column prop="startNumber" label="期初数量/包"> </el-table-column>
            <el-table-column prop="startWeight" label="期初重量"> </el-table-column>
            <el-table-column prop="startMoney" label="期初金额"> </el-table-column>
            <el-table-column prop="buyNumber" label="入库数量/包"> </el-table-column>
            <el-table-column prop="buyWeight" label="入库重量"> </el-table-column>
            <el-table-column prop="buyMoney" label="入库金额"> </el-table-column>
            <el-table-column prop="outNumber" label="出库数量"> </el-table-column>
            <el-table-column prop="outWeight" label="出库重量"> </el-table-column>
            <el-table-column prop="outMoney" label="出库金额"> </el-table-column>
            <el-table-column prop="inventNumber" label="盈亏数量/包"> </el-table-column>
            <el-table-column prop="inventWeight" label="盈亏重量"> </el-table-column>
            <el-table-column prop="inventMoney" label="盈亏金额"> </el-table-column>
            <el-table-column prop="stockNumber" label="期末数量/包"> </el-table-column>
            <el-table-column prop="stockWeight" label="期末重量"> </el-table-column>
            <el-table-column prop="stockMoney" label="期末金额"> </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="uyu-pagination">
            <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
              :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="pageNo" :pageSize.sync="pageSize"
              :totalCount="totalCount">
            </MyPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyPagination from "@/components/pc/my-pagination.vue";
import Page from "@/utils/methods/page";
import {
  getPageByFodderArea,
  exportByFodderArea,
  queryBaseGroupList,
  getBaseListsByUser,
  getFodders,
} from "./ym-feed-services";
export default {
  name: "day-ym-feed-in-out",
  data() {
    return {
      orgName: "",
      monthRange: [],
      dateRange: [],
      PageDisplay: true,
      showYear: "", // 显示的年份
      showStartDate: "", // 显示的开始日期
      showEndDate: "", // 显示的结束日期
      fodderList: [], // 饲料名称列表
      // 分页列表
      pagelist: {
        list: [],
      },
      pageNo: 1,
      pageSize: 13,
      totalCount: 0,
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "feedingTime",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "fodderName",
          fixed: false,
          selected: false
        },
        {
          prop: "specification",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 13,
        orderBy: "desc",
        orderByName: "date",
        params: {
          orgId: "",
          baseId: "",
          groupId: "",
          startDate: "", // 开始时间(如果是日则2019-01-01)
          endDate: "", // 结束时间
          type: "Y", // Y表示年,M表示按月查询,D表示近日查询
          year: localStorage.getItem("m-year") ? localStorage.getItem("m-year") : this.$moment().year().toString(), // 如果type为Y则year不能为空,如果type不为Y year一定要为null
          fodderId: "",
          total: false,
        },
      },
      baseList: [],
      groupList: [],
      boxList: [],
      exportParams: {}, // 导出参数
    };
  },
  computed: {},
  methods: {
    // 查询
    search() {
      this.params.currPage = 1;
      this.getPageList();
    },
    // 重置
    reset() {
      this.params.params.baseId = this.baseList[0].id;
      this.getGroups(this.params.params.baseId);
      this.params.params.type = "";
      this.params.params.startDate = "";
      this.params.params.endDate = "";
      this.params.params.year = localStorage.getItem("m-year") ? localStorage.getItem("m-year") : new Date().getFullYear().toString();
      this.params.params.fodderId = "";
      this.params.params.total = false;
      this.changeTime("Y");
      this.params.currPage = 1;
      this.params.pageSize = 13;
      this.getPageList();
    },
    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.date === "合计") {
        return "heji-row";
      }
    },
    // 选择月
    monthChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val[0];
      this.params.params.endDate = val[1];
    },
    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val[0];
      this.params.params.endDate = val[1];
    },
    /**
     * @Author: lishiqiao
     * @Date: 2021-07-30 10:01:25
     * @description: 改变当前分页总数
     * @param {any} event
     */
    handleSizeChange(event) {
      this.params.currPage = 1;
      this.params.pageSize = event;
      this.getPageList(this.params);
    },
    /**
     * @Author: lishiqiao
     * @Date: 2021-07-30 09:56:51
     * @description: 切换当前页
     * @param {any} event
     */
    handleCurrentChange(event) {
      this.params.currPage = event;
      this.getPageList(this.params);
    },
    // 分页
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getPageByFodderArea(this.params).then((data) => {
        if (data.code == "0000") {
          this.pagelist = data.data;
          this.pageNo = data.data.pageNumber;
          this.pageSize = data.data.pageSize;
          this.totalCount = data.data.totalCount;
          // 导出的参数 解决选择了查询条件但没有点击查询时导出数据不一致的bug
          this.exportParams = JSON.parse(JSON.stringify(this.params));
        }
        loading.close();
      });
    },
    // 导出
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        const params = {
          titleName: "饲料进出存列表",
          sheetName: "列表",
          fileName: "饲料进出存列表",
          param: this.params,
        };
        Page.exportDatas(exportByFodderArea(), params);
      });
    },
    getBases() {
      // 养殖场
      getBaseListsByUser().then((res) => {
        if (res.code == "0000") {
          this.baseList = res.data;
          this.params.params.baseId = this.baseList[0].id;
          this.params.params.groupId = "";
          this.getGroups();
        }
      });
    },
    // 仓库
    getGroups() {
      queryBaseGroupList(this.params.params.baseId).then((res) => {
        if (res.code == "0000") {
          this.groupList = res.data;
        }
      });
    },
    /**
     * 根据时间段查询数据
     * @param time
     */
    changeTime(time) {
      this.params.params.type = time;
      if (time === "D" || time === "M") {
        // 当前选择具体日期
        this.params.params.year = null;
      } else {
        if (time === "Y") {
          // 当前选择月份 / 年份
          this.params.params.startDate = "";
          this.params.params.endDate = "";
          this.monthRange = [];
          this.dateRange = [];
        }
      }
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  components: { MyPagination },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
    Page.pagesTableFixed(); // 表头固定
  },
  created() {
    this.tableHeight = window.innerHeight - 450;
    this.params.params.orgId = localStorage.getItem("orgId");
    // this.params.params.orgId = "7a5cfc1b-1cbe-445a-915a-d31cc9c9649e";
    this.orgName = localStorage.getItem("orgName");
    this.getBases();
    // 饲料
    getFodders(this.params.params.orgId).then((res) => {
      if (res.code == "0000") {
        this.fodderList = res.data;
      }
    });
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
.uyu-pagination {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #5442ff;
  border-color: #5442ff;
}

/deep/.el-checkbox__inner:hover {
  border-color: #5442ff;
}
</style>